<div class="container report-page">
  <div class="admin-page-header">
    <h1 class="admin-page-title">Invoices</h1>
    <div class="summary-chip">Total: {{ payments.length }}</div>
  </div>

  <mat-card class="report-summary-card">
    <div>Total facturado: {{ resumen.total | currency:'EUR' }}</div>
  </mat-card>

  <mat-card class="table-card">
    <app-filter [filters]="fieldFilters" (submit)="send()"></app-filter>
  </mat-card>

  <mat-card class="table-card">
    <div class="table-container">
      <table class="table report-table">
        <thead>
          <tr>
            <th>totalPrice</th>
            <th>status</th>
            <th>type</th>
            <th>createdAt</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let payment of payments" (click)="setOpen(payment)" [attr.title]="payment.uuid">
            <th scope="row">{{ payment.totalPrice }}</th>
            <td>{{ payment.status }}</td>
            <td>{{ payment.type }}</td>
            <td>{{ payment.createdAt | date: appService.FORMAT_DATETIME }}</td>
          </tr>
          <tr *ngIf="payments.length === 0">
            <td colspan="4">
              <div class="empty-row">
                <mat-icon>inbox</mat-icon>
                <span>No hay resultados</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-card>
</div>
